import xw from 'xwind';
import styled from '@emotion/styled';

export const NavigationButton = styled.button`
  ${xw`
    z-10 absolute bg-white border border-gray-100
    text-gray-200 rounded-full focus:outline-none`}

  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  background-color: white !important;

  width: 40px !important;
  height: 40px !important;

  @media screen and (max-width: 640px) {
    width: 32px !important;
    height: 32px !important;
  }
`;

export const IconWrapper = styled.div(
  xw`w-full h-full flex justify-center items-center`,
);

export const IconContainer = styled.div<{ color?: string }>`
  width: 9px;

  color: ${({ color }) => color};
`;

export const NavigationButtonPrevious = styled(NavigationButton)`
  margin-left: 12px;

  @media screen and (max-width: 640px) {
    margin-left: 16px;
  }
`;

export const NavigationButtonNext = styled(NavigationButton)`
  margin-right: 12px;

  @media screen and (max-width: 640px) {
    margin-right: 16px;
  }
`;
